import React from "react";
import { SpinnerButton } from "../SpinnerButton";
import { CreatePageBlock } from "./CreatePageBlock";

type Props = {
  state: {
    /**
     * The current state of the button.
     *
     * `"enabled"`: The button is enabled and can be clicked.
     *
     * `"disabled"`: Something is wrong with the form and the button cannot be clicked.
     *
     * `"submitting"`: The button is disabled and a spinner is shown.
     */
    type: "enabled" | "disabled" | "submitting";
    text: string;
  };
};

export const CreatePageSubmitButton: React.FC<Props> = (props) => {
  const { state } = props;

  const disabled = state.type !== "enabled";
  const spinning = state.type === "submitting";

  return (
    <CreatePageBlock>
      <SpinnerButton inline type="submit" disabled={disabled} spinning={spinning} variation="success">
        {state.text}
      </SpinnerButton>
    </CreatePageBlock>
  );
};

CreatePageSubmitButton.displayName = "CreatePageSubmitButton";
